import { useCalendars } from 'expo-localization'
import { useBuilding, useLocation, useLocations } from 'zens-store'
import { getTimezoneOffset } from 'date-fns-tz'

interface Config {
  companyId: number
  buildingId?: number
}

export function useTimeZoneConflict(config: Config) {
  const { companyId, buildingId = 0 } = config
  const building = useBuilding({ companyId, buildingId })
  const locations = useLocations({ companyId }, { enabled: !buildingId })
  const location = useLocation({ companyId, locationId: building.data?.locationId || 0 })
  const calendars = useCalendars()

  function getBuildingTimeZones() {
    if (buildingId && !building.data) return
    if (buildingId && building.data?.timeZoneId) return [building.data?.timeZoneId]
    if (!location.data) return
    return [location.data?.timeZoneId]
  }

  function getLocationTimeZones() {
    if (!locations.data) return
    return locations.data?.map((location) => location.timeZoneId)
  }

  const currentTimeZone = calendars?.[0].timeZone
  const contextTimezones = buildingId ? getBuildingTimeZones() : getLocationTimeZones()
  if (!currentTimeZone || !contextTimezones) return undefined
  return contextTimezones.some((timezone) => getTimezoneOffset(timezone) !== getTimezoneOffset(currentTimeZone))
}
